module.exports = __webpack_public_path__ + "static/media/cup_gun_metal.218a6097.png";